import React, { useState, useEffect } from "react";
import styles from "./CountPillGrey.module.scss";

export const CountPillGrey = (props) => {
  const { count } = props;

  return <span className={styles.pill}>{count}</span>;
};
